export class InsuranceDocumentConstant {
  public static readonly Tune_Car_PDS = "https://quotation.bmsroadtax.com/assets/product-disclosure/tune/Motor_PDS.pdf";
  public static readonly Tune_Car_PW = "https://quotation.bmsroadtax.com/assets/product-disclosure/tune/Motor_PW.pdf";
  public static readonly Tune_Bike_PDS = "https://quotation.bmsroadtax.com/assets/product-disclosure/tune/Bike_PDS.pdf";
  public static readonly Tune_Bike_PW = "https://quotation.bmsroadtax.com/assets/product-disclosure/tune/Bike_PW.pdf";
}
